<template>
  <div class="bg-white mobile-wrapper" :style="getCheckoutRolldStyles()">
    <div v-if="fetchingData">
      <Transition name="slide-fade">
        <progress-indicator />
      </Transition>
    </div>
    <div v-else>
      <payment-indicator
        v-if="showPaymentIndicator"
        :is-pay-later="placingPayLaterOrder"
        :is-pending="proccessing"
        :succeeded="paymentSucceeded"
        @hide="hidePaymentIndicator"
      ></payment-indicator>
      <div :class="showNewUi ? 'new-fixed-banner' : 'fixed-banner'">
        <div
          :style="getCheckoutRolldStyles()"
          class="container-fluid banner-alt"
        >
          <div class="row">
            <div class="col-12 banner-title">
              <div>
                <span
                  class="material-icons md-36"
                  @click="navigateToShoppingCart"
                  >keyboard_arrow_left</span
                >
                <span
                  v-if="showNewUi"
                  class="title-text"
                  @click="navigateToShoppingCart"
                >
                  {{ $t("message.secureCheckout") }}
                </span>

                <span v-else class="title-text" @click="navigateToShoppingCart">
                  {{ $t("message.checkout") }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- /banner -->
      </div>
      <div class="content-padding" />

      <!--    <div-->
      <!--      v-show="!showBecomeMember"-->
      <!--      v-if="!user && viewConfig.LogIn"-->
      <!--      class="login-warning"-->
      <!--      role="alert"-->
      <!--      :style="mobileStyles.alertInfoBackGround"-->
      <!--    >-->
      <!--      <router-link-->
      <!--        :style="mobileStyles.btn"-->
      <!--        class="btn btn-primary pr-2"-->
      <!--        :to="'/login/' + this.storeid + '/false'"-->
      <!--        >{{ $t("message.login") }}</router-link-->
      <!--      >-->
      <!--      <span class="pl-2 rolld-primary-color" style="vertical-align: middle">-->
      <!--        {{ $t("message.placeAnOrderAsGuestWithoutCreatingAccount") }}-->
      <!--      </span>-->
      <!--    </div>-->
      <form @submit.prevent="placeOrder">
        <div :class="showNewUi && 'new-checkout'" class="container mt-2">
          <div v-show="!showBecomeMember" class="row">
            <div class="col-12">
              <div :style="getCheckoutRolldStyles()" class="bg-white mb-2">
                <div class="d-flex justify-content-center">
                  <div class="w-100">
                    <h4 v-show="showGettingYourMealMessage()">
                      {{ $t("message.gettingYourOrder") }}
                    </h4>
                    <div
                      aria-label="Basic example"
                      class="btn-group flex-wrap"
                      role="group"
                    >
                      <button
                        v-show="isEnableTab('delivery')"
                        :style="btnStyle(isDelivery, true)"
                        class="btn screamer-font"
                        type="button"
                        @click="deliveryMode"
                      >
                        {{ $t("message.checkoutDelivery") }}
                      </button>
                      <h3
                        v-if="isEnableTab('pickUp') && isRolldStore()"
                        class="screamer-font"
                        style="margin-top: 10px; margin-right: 12px"
                      >
                        |
                      </h3>
                      <button
                        v-if="isEnableTab('pickUp')"
                        :style="btnStyle(isPickup, true)"
                        class="btn screamer-font"
                        type="button"
                        @click="pickupMode"
                      >
                        {{ $t("message.pickUp") }}
                      </button>
                      <h3
                        v-if="isEnableTab('deliverToRoom') && isRolldStore()"
                        class="screamer-font"
                        style="margin-top: 10px; margin-right: 12px"
                      >
                        |
                      </h3>
                      <button
                        v-if="isEnableTab('deliverToRoom')"
                        :style="btnStyle(isChargeToRoom, true)"
                        class="btn screamer-font"
                        type="button"
                        @click="chargeToRoomMode"
                      >
                        {{ $t("message.deliverToRoom") }}
                      </button>
                      <h3
                        v-if="isEnableTab('dineIn') && isRolldStore()"
                        class="screamer-font"
                        style="margin-top: 10px; margin-right: 12px"
                      >
                        |
                      </h3>
                      <button
                        v-if="isEnableTab('dineIn')"
                        :style="btnStyle(isEatIn, true)"
                        class="btn screamer-font"
                        type="button"
                        @click="eatInMode"
                      >
                        {{ $t("message.dineIn") }}
                      </button>
                    </div>
                    <pickup-address
                      v-show="
                        isPickup &&
                        !pickupDisabled &&
                        !viewConfig.HideAddressOnPickup
                      "
                    />
                    <my-detail
                      v-if="!selectedCompany.ChargeToRoom && !isEatIn"
                      ref="myDetails"
                      :charge-to-room="selectedCompany.ChargeToRoom"
                      :disableNameField="disableNameField"
                      :display-mobile-field="displayMobileField"
                      :displayEmailField="displayEmailField"
                      :edit-model="detailModel"
                      :for-gift="false"
                      @save-user="saveUser"
                    />
                    <delivery-address
                      v-if="isDelivery && googleLoaded"
                      ref="deliveryAddress"
                      :edit-model="deliveryAddressModel"
                      @estimationUpdated="
                        (newAddress) =>
                          setDeliveryTimes(
                            deliveryDate,
                            true,
                            false,
                            newAddress ? null : selectedDeliveryTime
                          )
                      "
                      @postalCodeUpdate="updatePostalCodeHandler"
                    />

                    <div
                      v-show="isDeliveryUnavailable"
                      class="order-type-address-error"
                    >
                      {{
                        getDeliveryAddressMessage ||
                        $t("message.sorryWeCannotDeliverToThisAddress")
                      }}
                    </div>
                    <div
                      v-show="!isChargeToRoom && (isDelivery || isPickup)"
                      :class="!showNewUi && 'mt-4'"
                      class="form-row"
                    >
                      <div
                        v-if="
                          selectedCompany.EnablePreoderForDelivery && isDelivery
                        "
                        class="form-group col-12"
                      >
                        <label class="required" for="date-select">
                          {{ $t("message.deliveryDate") }}
                        </label>
                        <date-picker
                          v-model="deliveryDate"
                          :disabledDates="deliveryDisabledDates"
                          bootstrap-styling
                          @closed="deliveryDateChanged(deliveryDate)"
                        ></date-picker>
                      </div>
                      <div
                        v-if="
                          selectedCompany.EnablePreoderForPickup && isPickup
                        "
                        class="form-group col-12"
                      >
                        <label class="required" for="date-select">
                          {{ $t("message.pickupDate") }}
                        </label>
                        <date-picker
                          v-model="pickupDate"
                          :disabledDates="pickupDisabledDates"
                          bootstrap-styling
                          @closed="
                            setPickupTimes(
                              pickupDate,
                              false,
                              selectedPickupTime
                            )
                          "
                        ></date-picker>
                      </div>
                      <div v-show="isDelivery" class="form-group col-12">
                        <label class="required" for="time-select">{{
                          $t("message.deliveryTime")
                        }}</label>
                        <vselect
                          v-model="selectedDeliveryTime"
                          :clearable="false"
                          :disabled="getDeliveryIsLoading"
                          :options="dtimes"
                          :reduce="(slot) => slot.to"
                          :searchable="false"
                          label="format"
                          name="dtime-select"
                          @input="
                            selectedDeliveryTimeChange(selectedDeliveryTime)
                          "
                        >
                        </vselect>
                        <div class="invalid-feedback">
                          {{
                            OOErrors.first("deliveryTime")
                              | inputNameLocale("deliveryTime")
                          }}
                        </div>
                      </div>
                      <div v-show="isPickup" class="form-group col-12">
                        <label
                          v-show="isPickup"
                          class="required"
                          for="time-select"
                          >{{ $t("message.pickupTime") }}</label
                        >

                        <vselect
                          v-model="selectedPickupTime"
                          :clearable="false"
                          :options="pickupTimes"
                          :reduce="(slot) => slot.time"
                          :searchable="false"
                          label="format"
                          name="time-select"
                          @input="selectedPickupTimeChange(selectedPickupTime)"
                        >
                        </vselect>
                        <div class="invalid-feedback">
                          {{
                            OOErrors.first("pickupTime")
                              | inputNameLocale("pickupTime")
                          }}
                        </div>
                      </div>
                    </div>
                    <!-- <label
                      v-show="isDelivery && isDeliveryTimeSlotsEnable"
                      class="required"
                      >{{ $t("message.deliveryTime") }}</label
                    >
                    <div v-show="isDelivery" class="form-row">
                      <button
                        class="btn time-slot-btn asap"
                        style="padding: 2px;"
                        v-for="(timeSlot, index) in dtimes.filter(
                          (p) => p.format.indexOf('ASAP') >= 0
                        )"
                        :key="index"
                        @click="selectedDeliveryTime = timeSlot.time"
                        :style="
                          getTimeSlotStyle(selectedDeliveryTime == timeSlot.time)
                        "
                        :disabled="getDeliveryIsLoading"
                      >
                        <span>ASAP</span>
                        <br />
                        <span>{{
                          timeSlot.format.split("(")[1].split(")")[0]
                        }}</span>
                      </button>
                      <button
                        type="button"
                        class="btn time-slot-btn"
                        v-for="(timeSlot, index) in dtimes.filter(
                          (p) => p.format.indexOf('ASAP') < 0
                        )"
                        :key="index"
                        @click="selectedDeliveryTime = timeSlot.time"
                        :style="
                          getTimeSlotStyle(selectedDeliveryTime == timeSlot.time)
                        "
                        :disabled="getDeliveryIsLoading"
                      >
                        {{ timeSlot.format }}
                      </button>
                    </div> -->
                    <room-delivery
                      v-if="isChargeToRoom"
                      ref="roomDelivery"
                      :edit-model="roomDeliveryModel"
                    />
                    <eat-in
                      v-if="isEatIn"
                      ref="eatIn"
                      :edit-model="eatInModel"
                      :is-pay-by-card="isPayByCard"
                      @save-user="saveUser"
                    ></eat-in>

                    <div v-show="viewConfig.ShowNotes" class="form-row">
                      <div
                        class="form-group col-sm-12"
                        style="margin-bottom: 0"
                      >
                        <div class="d-flex">
                          <h4>
                            {{ $t("message.notes") }}
                          </h4>
                          <b-icon-plus
                            v-if="!notesVisible"
                            style="margin-top: -1px"
                            @click="notesVisible = true"
                          ></b-icon-plus>
                          <b-icon-dash
                            v-else
                            style="margin-top: -1px"
                            @click="notesVisible = false"
                          ></b-icon-dash>
                        </div>

                        <b-collapse id="collapse-2" v-model="notesVisible">
                          <textarea
                            id="notes"
                            v-model="notes"
                            :class="{ 'rolld-textarea': isRolldStore() }"
                            class="form-control"
                            maxlength="300"
                            name="notes"
                            type="text"
                          />
                        </b-collapse>
                      </div>
                    </div>
                    <div
                      v-if="showChargeToRoom()"
                      :class="isChargeToRoom ? 'mt-4 xxxx' : 'mt-2 xxxx'"
                    >
                      <payment-type
                        :card-value-in-point="payByPoint.cardValueInPoint"
                        :is-pay-by-cash-enable="isPayByCashEnable"
                        :is-pay-by-point-enable="payByPoint.canPay"
                        :value="paymentMethod"
                        @set-payment-method="setPaymentMethod"
                        @set-show-pay-by-apple="setCanPayByApple"
                        @set-show-pay-by-google="setCanPayByGoogle"
                      ></payment-type>
                    </div>

                    <template v-if="!onlyPayLater">
                      <div
                        v-if="getLivenPay && getTotalPrice > 0"
                        class="mt-3 mb-2"
                      >
                        <h4>Pay Securely</h4>
                        <div class="form-row">
                          <div class="col-sm-12">
                            <button
                              :class="
                                payButtonsAreDisabled ||
                                (!livenDisplay && this.isMobile())
                                  ? 'disabled'
                                  : ''
                              "
                              :style="livenButtonStyles"
                              class="btn btn-danger btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
                              role="button"
                              @click="livenPayment(10)"
                              target="_blank"
                            >
                              <span v-if="proccessing && paymentMethod == 10">
                                <i class="spin-sm ml-4" />
                              </span>
                              <img
                                v-else
                                class="liven-button"
                                src="../../../assets/images/logos/liven.png"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-if="canPayByPointsPartially">
                        <div class="form-row mt-2">
                          <div class="form-group col-sm-12">
                            <div
                              class="card shadow"
                              style="border-radius: 10px"
                            >
                              <div
                                class="d-flex flex-row justify-content-around align-items-center p-3"
                              >
                                <b-form-checkbox
                                  id="checkbox-1"
                                  v-model="useLoyaltyPointsBalance"
                                  name="checkbox-1"
                                  style="margin-top: -2.3rem"
                                />

                                <span style="font-size: 0.85rem">
                                  {{
                                    $t("message.payByLoyaltyPointsPartially")
                                  }}
                                </span>

                                <span
                                  :class="{ 'text-success': !isRolldStore() }"
                                  class="payByPoint-span"
                                  style="font-size: 0.85rem"
                                >
                                  -{{
                                    Math.ceil(payByPoint.userPoints)
                                      | formatNumber
                                  }}
                                  pts ({{
                                    payByPoint.pointsValue
                                      | formatMoney(currencySign)
                                  }})
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="canPayByPoints" class="mt-4">
                        <div class="form-row">
                          <div class="col-sm-12">
                            <button
                              :class="showNewUi && 'bg-dark'"
                              :disabled="payButtonsAreDisabled"
                              :style="orderButtonStyles"
                              class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
                              type="button"
                              @click.prevent="setMethodAndPlaceOrder(2)"
                            >
                              {{ $t("message.payByLoyaltyPoints") }} &nbsp;
                              <span
                                :class="{
                                  'text-success': !isRolldStore() && !showNewUi,
                                }"
                                class="payByPoint-span"
                              >
                                -{{
                                  Math.ceil(payByPoint.cardValueInPoint)
                                    | formatNumber
                                }}
                                pts ({{
                                  getTotalPrice | formatMoney(currencySign)
                                }})
                              </span>
                              <span v-show="proccessing && paymentMethod === 2">
                                <i class="spin-sm ml-4" />
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-if="isPayByCashEnable" class="mt-4">
                        <pay-by-cash
                          :get-total-price="getTotalPrice"
                          :payButtonsAreDisabled="payButtonsAreDisabled"
                          :proccessing="proccessing"
                          :selected-payment-method="paymentMethod"
                          @setPaymentMethod="setPaymentMethod"
                          @set-method-and-place-order="setMethodAndPlaceOrder"
                        />
                      </div>
                      <div v-if="getTotalPrice > 0">
                        <google-pay
                          ref="stripePayRef"
                          :disabled="getDeliveryIsLoading"
                          :selected-payment-method="paymentMethod"
                          @error="googlePaymentError"
                          @finalize="finalizeStripePayment"
                          @proccessing="updateProcessing"
                          @setPaymentMethod="setPaymentMethod"
                          @validate="placeOrder"
                          @validateOrder="validateOrder"
                          @stripe-click="setMethodAndPlaceOrder"
                        />
                      </div>

                      <div v-if="getTotalPrice > 0">
                        <payment
                          ref="payment"
                          :can-pay-by-other-than-card="canPayByOtherThanCard"
                          :dbuser="userInfo"
                          :edit-model="paymentModel"
                          :selected-payment-method="paymentMethod"
                          :user="user"
                          :customerID="customerID"
                          :storeID="storeid"
                          @setPaymentMethod="setPaymentMethod"
                          @save-credit="saveCredit"
                        />
                      </div>
                      <div class="mt-4">
                        <div class="form-row">
                          <!--                        <div class="col-sm-12" v-if="showNewUi">-->
                          <!--                          <button-->
                          <!--                            type="button"-->
                          <!--                            @click.prevent="setMethodAndPlaceOrder(1)"-->
                          <!--                            :disabled="payButtonsAreDisabled"-->
                          <!--                            class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"-->
                          <!--                            :style="payCounterButtonStyles"-->
                          <!--                          >-->
                          <!--                            {{ $t("message.payAtCounter") }}-->
                          <!--                          </button>-->
                          <!--                        </div>-->
                          <div class="col-sm-12">
                            <button
                              :disabled="payButtonsAreDisabled"
                              :style="orderButtonStyles"
                              class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
                              type="button"
                              @click.prevent="
                                setMethodAndPlaceOrder(paymentMethod || 1)
                              "
                            >
                              {{ $t("message.payNow") }} ({{
                                getTotalPrice | formatMoney(currencySign)
                              }})
                              <span v-show="proccessing">
                                <i class="spin-sm ml-4" />
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </template>

                    <div v-if="canPayLater">
                      <div class="pt-2 mb-2">
                        <div :class="{ disableItem: SelecteDPTime() }">
                          <div class="row">
                            <div class="col-sm-12">
                              <button
                                :style="orderButtonStyles"
                                class="btn btn-primary btn-lg btn-block mb-2 d-flex justify-content-center align-items-center"
                                type="button"
                                @click.prevent="payLaterButtonClicked"
                              >
                                {{ payLaterButtonText }}
                                <span
                                  v-show="proccessing && paymentMethod == 8"
                                >
                                  <i class="spin-sm ml-4" />
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="isLoyaltyMarketingEnabled & !isRolldStore()">
                      <div :class="!showNewUi && 'mt-4'" class="form-row">
                        <div class="form-group col-sm-12 joinourmail">
                          <input
                            id="joinourmail"
                            v-model="JoinOurMail"
                            name="joinourmail"
                            type="checkbox"
                            value="joinourmail"
                          />
                          <label for="joinourmail"
                            >Join our mailing list!</label
                          >
                          <p class="label">
                            By signing up you are agreeing to receive
                            information, promotional material as well as
                            exclusive offers.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div v-show="error" class="w-100 mt-4">
                      <div class="alert alert-danger" role="alert">
                        <strong v-html="error"></strong>
                      </div>
                    </div>
                    <div v-show="!exceedMinPurchase" class="w-100 mt-4">
                      <div class="alert alert-danger" role="alert">
                        <strong>
                          {{ $t("message.minimumPurchaseIs") }}
                          {{ minPurchase | formatMoney(currencySign) }}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--        <div class="row" v-if="showBecomeMember">-->
          <!--          <div class="col-12">-->
          <!--            <h4>{{ $t("message.becomeMember") }}</h4>-->
          <!--            <p>{{ $t("message.fasterCheckoutManageOrdersEarnPoints") }}</p>-->
          <!--            <footer class="extras-footer">-->
          <!--              <button-->
          <!--                type="button"-->
          <!--                class="btn btn-cancel"-->
          <!--                @click="setBecomeMember(true)"-->
          <!--              >-->
          <!--                {{ $t("message.skip") }}-->
          <!--              </button>-->
          <!--              <button-->
          <!--                type="button"-->
          <!--                class="btn btn-primary"-->
          <!--                :style="mobileStyles.btn"-->
          <!--                @click="setBecomeMember(true)"-->
          <!--              >-->
          <!--                <span>{{ $t("message.becomeMember") }}</span>-->
          <!--              </button>-->
          <!--            </footer>-->
          <!--          </div>-->
          <!--        </div>-->
        </div>
      </form>

      <Poweredby v-if="showNewUi" />

      <modal
        v-if="showClearCartModal"
        ref="ClearCartModal"
        full-header
        @close="closeClearCartModal"
      >
        <template slot="body">
          <div class="container">
            <p class="py-4">
              {{
                $t("message.clearCartMessage", {
                  OrderType: getSelectedOrderTypeName,
                })
              }}
            </p>
          </div>
        </template>
        <template slot="footer" class="bg-body">
          <div
            class="w-100 d-flex gap-20 justify-content-center"
            style="z-index: 2"
          >
            <button
              class="privacy-btn mr-3"
              data-dismiss="modal"
              type="button"
              @click="cancelClearCart()"
            >
              {{ $t("message.cancel") }}
            </button>
            <button
              class="privacy-btn"
              data-dismiss="modal"
              type="button"
              @click="confirmClearCart()"
            >
              {{ $t("message.ok") }}
            </button>
          </div>
          <div class="privacy-footer" />
        </template>
      </modal>

      <modal
        v-if="showPrivacyModal"
        ref="privacyModal"
        full-header
        @close="closePrivacyPolicyModal"
      >
        <template slot="body">
          <div class="container">
            <div class="d-flex justify-content-center">
              <h2 class="p-2 mt-2 privacy-header">
                {{ $t("message.termsAndConditions") }}
              </h2>
            </div>
            <p
              class="py-4 terms-and-conditions ios-scroll"
              v-html="selectedCompany.TermsAndConditions"
            ></p>
          </div>
        </template>
        <template slot="footer" class="bg-body">
          <div class="w-100" style="z-index: 2">
            <button
              :style="buttonStyles"
              class="privacy-btn pull-right"
              data-dismiss="modal"
              type="button"
              @click="closePrivacyPolicyModal()"
            >
              {{ $t("message.ok") }}
            </button>
          </div>
          <div class="privacy-footer" />
        </template>
      </modal>
      <modal
        v-if="payLaterPopup"
        ref="privacyModal"
        full-header
        @close="togglePayLaterPopup"
      >
        <template slot="body">
          <div class="container">
            <div class="d-flex justify-content-center">
              <h2 class="p-2 mt-2 privacy-header">
                {{ currentStoreDoc.PayLaterPopupTitle }}
              </h2>
            </div>
            <p
              class="py-4 terms-and-conditions ios-scroll"
              v-html="currentStoreDoc.PayLaterPopupDescription"
            ></p>
          </div>
        </template>
        <template slot="footer" class="bg-body">
          <div style="z-index: 2">
            <button
              class="privacy-btn pull-right"
              data-dismiss="modal"
              type="button"
              @click.prevent="setMethodAndPlaceOrder(8)"
            >
              {{ $t("message.confirm") }}
            </button>
          </div>
          <div class="privacy-footer" />
        </template>
      </modal>

      <!--       should register account popup-->
      <modal
        v-if="showBecomeMember"
        ref="becomeMemberModal"
        top-margin="35vh"
        @close="() => (this.showBecomeMember = false)"
      >
        <template slot="body">
          <div class="container">
            <div class="d-flex justify-content-center">
              <h2 class="p-2 mt-2">Register</h2>
            </div>
            <p class="py-4 text-center">
              {{ $t("message.doRegisterNewAccount") }}
            </p>
          </div>
        </template>
        <template slot="footer" class="bg-body">
          <div style="z-index: 2">
            <button
              class="btn btn-outline-dark pull-right"
              data-dismiss="modal"
              type="button"
              @click.prevent="saveUserAndCheckout"
            >
              {{ $t("message.register") }}
            </button>
          </div>

          <div style="z-index: 2">
            <button
              class="btn btn-outline-dark pull-right"
              data-dismiss="modal"
              type="button"
              @click.prevent="skipRegisterAndCheckout"
            >
              {{ $t("message.skip") }}
            </button>
          </div>
          <div class="privacy-footer" />
        </template>
      </modal>

<!--      liven redirect modal-->
      <modal
          v-if="displayLivenRedirectPopup"
          ref="livenRedirectModal"
          top-margin="35vh"
          @close="toggleLivenRedirectPopup"
      >

        <template slot="body">
          <div class="container">
            <div class="d-flex justify-content-center text-center">
              <h2 class="p-2 mt-2">{{ $t("message.RedirectToLiven") }}</h2>
            </div>
            <p class="py-4 text-center">
              {{ $t("message.EnsureLivenInstalled") }}
            </p>
          </div>
        </template>
        <template slot="footer" class="bg-body">


          <div style="z-index: 2">
            <button
                class="btn btn-outline-dark pull-right"
                data-dismiss="modal"
                type="button"
                @click.prevent="toggleLivenRedirectPopup"
            >
              {{ $t("message.cancel") }}
            </button>
          </div>

          <div style="z-index: 2">
            <button
                class="btn btn-outline-dark pull-right"
                data-dismiss="modal"
                type="button"
                @click.prevent="redirectToLiven"
            >
              {{ $t("message.confirm") }}
            </button>
          </div>
        </template>



      </modal>

      <paylater-alert :type="1" v-if="showCheckoutAlert"></paylater-alert>
      <paylater-alert :type="2" v-if="showFreqAlert"></paylater-alert>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.navigate-user-wrapper {
  display: flex;
  align-items: baseline;
  &:hover {
    cursor: pointer;
  }
  img {
    margin-right: 8px;
  }
}
</style>

<script>
import MyDetail from "./partials/MyDetail";
import DeliveryAddress from "./partials/DeliveryAddress";
import Payment from "./partials/Payment";
import PickupAddress from "./partials/PickupAddress";
import RoomDelivery from "./partials/RoomDelivery";
import EatIn from "./partials/EatIn";
import DatePicker from "vuejs-datepicker";
import shared from "../../../sharedscripts/shop/Checkout/Checkout.js";
import { mapGetters, mapActions } from "vuex";
import modal from "../../modal";
import GooglePay from "./partials/GooglePay";
import paymentType from "./paymentType";
import PaymentIndicator from "../../shop/Checkout/partials/PaymentIndicator";
import { orderTypeHelper } from "../../../api/helpers/orderTypeHelper";
import Poweredby from "@/components/shared/poweredby";
import vselect from "vue-select";
import PayByCash from "@/components/shop/Checkout/partials/PayByCash";
import { BIconPlus, BIconDash } from "bootstrap-vue";
import { getDBUser } from "@/api/services/userService";
import { logger } from "@/api/Logger";
import ProgressIndicator from "@/components/progressindicator";
import paylaterAlert from "../../shared/paylaterAlert.vue";
import { readProductData } from "../../../api/helpers/rtdbHelper";
import { isiOS, sleep } from "../../../api/helpers/commonHelpers";
import { setUpTrackingOrderListener } from "../../../api/services/orderService.js";

export default {
  components: {
    PayByCash,
    vselect,
    Poweredby,
    MyDetail,
    DeliveryAddress,
    Payment,
    PickupAddress,
    RoomDelivery,
    EatIn,
    DatePicker,
    modal,
    GooglePay,
    paymentType,
    PaymentIndicator,
    BIconPlus,
    BIconDash,
    ProgressIndicator,
    paylaterAlert,
  },
  props: {
    storeid: {
      type: String,
      default: "",
    },
    forGiftCart: {
      type: Boolean,
      default: false,
    },
    orderid: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showBecomeMember: false,
      becomeMemberShown: false,
      userIsExist: false,
      error: "",
      isDelivery: false,
      notes: "",
      pickupDisabledDates: {},
      deliveryDisabledDates: {},
      deliveryDate: "",
      pickupDate: "",
      disabledDates: {},
      isPickup: false,
      isChargeToRoom: false,
      isEatIn: false,
      dtimes: [],
      pickupTimes: [],
      selectedDeliveryTime: "",
      selectedPickupTime: "",
      showClearCartModal: false,
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: "",
        Password: "",
        ConfirmPassword: "",
        BirthDate: "",
      },
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null,
      },
      deliveryAddressModel: {
        StreetAddress: "",
        PostalCode: "",
        CityTown: "",
        DeliveryInstructions: "",
        State: "",
        Latitude: "",
        Longitude: "",
      },
      roomDeliveryModel: {
        RoomNumber: "",
        FirstName: "",
        LastName: "",
        Email: "",
      },
      eatInModel: {
        TableNumber: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Password: "",
        ConfirmPassword: "",
        BirthDate: "",
        PhoneNumber: "",
      },
      registerNew: false,
      saveCard: false,
      JoinOurMail: false,
      paymentMethod: 1,
      deliveryDisabled: false,
      pickupDisabled: false,
      userInfo: {},
      proccessing: false,
      showPaymentIndicator: false,
      paymentSucceeded: true,
      showPrivacyModal: false,
      guestUserId: null,
      googleLoaded: false,
      stripeToken: null,
      canPayByApple: false,
      canPayByGoogle: false,
      updateTimeListTimer: null,
      useLoyaltyPointsBalance: false,
      placingPayLaterOrder: false,
      payLaterPopup: false,
      fetchingData: false,
      livenDisplay: false,

      //  notes accordion
      notesVisible: false,
      showCheckoutAlert: false,
      showFreqAlert: false,
      customerID: "",

      // save liven redirect url
      livenUrl : "",
      displayLivenRedirectPopup : false,

      unsubscribe: null,
      orderIdentifier: "",
    };
  },

  computed: {
    ...shared.computed,
    ...mapGetters([
      "mobileStyles",
      "getSurchargeHolidayAmount",
      "getSurchargeBankAmount",
      "addressOutOfService",
      "cartValue",
      "getDeliveryAddressMessage",
      "user",
      "dbuser",
      "showNewUi",
      "getSelectedOrderTypeName",
      "viewConfig",
      "phoneNumber",
      "getLivenPay",
      "showSharedCart",
      "getSharedCartProps",
    ]),
    orderButtonStyles() {
      const styles = [];
      styles.push({
        ...this.mobileStyles.btn,
        ...this.mobileStyles.mobilePlaceOrderButton,
      });
      if (this.showNewUi) {
        styles.push({
          height: "48px",
        });
      }

      return styles;
    },

    livenButtonStyles() {
      const styles = [];
      styles.push({
        ...this.mobileStyles.btn,
        ...this.mobileStyles.mobilePlaceOrderButton,
        background: "#ff3c6e !important",
        height: "48px",
      });
      return styles;
    },

    payCounterButtonStyles() {
      return {
        ...this.mobileStyles.btn,
        ...this.mobileStyles.mobilePlaceOrderButton,
        opacity: "0.85",
      };
    },
    totalPrice() {
      return this.getTotalPrice;
    },
    isDeliveryUnavailable() {
      return (
        this.$route.name.toLowerCase().indexOf("checkout") >= 0 &&
        this.addressOutOfService &&
        this.deliveryAddress.StreetAddress != ""
      );
    },
    minPurchase() {
      var minPurchase = 0;
      if (this.selectedCompany) {
        if (this.selectedCompany.OrderTypeConstraintRules) {
          minPurchase = this.selectedCompany.OrderTypeConstraintRules[
            this.orderType
          ]
            ? this.selectedCompany.OrderTypeConstraintRules[this.orderType]
                .MinimumTotalPrice
            : 0;
        }
      }
      return minPurchase;
    },
    changeData() {
      const {
        eatInModel,
        detailModel,
        deliveryAddressModel,
        roomDeliveryModel,
      } = this;
      return {
        eatInModel,
        detailModel,
        deliveryAddressModel,
        roomDeliveryModel,
      };
    },
    changeOrderType() {
      const { isEatIn, isPickup, isDelivery } = this;
      return {
        isEatIn,
        isPickup,
        isDelivery,
      };
    },
  },
  watch: {
    viewConfig() {
      this.computeRules();
    },
    holder() {
      this.paymentModel.CardHolder = this.holder;
    },
    pickupDate() {
      this.pickupSurcharge();
    },
    deliveryDate() {
      this.deliverySurcharge();
    },
    dbuser() {
      this.userInfo = this.dbuser;
    },
    getTotalPrice() {
      this.remountStripeButton();
    },
    selectedDeliveryTime() {
      orderTypeHelper.setDeliveryTime(
        new Date(this.selectedDeliveryTime).toISOString()
      );
    },
    selectedPickupTime() {
      orderTypeHelper.setDeliveryTime(
        new Date(this.selectedPickupTime).toISOString()
      );
    },
    useLoyaltyPointsBalance(newValue) {
      if (newValue) {
        this.setPointsDiscount(this.payByPoint.pointsValue);
      } else {
        this.setPointsDiscount(0);
      }
    },
    payByPoint: {
      deep: true,
      handler(newValue) {
        if (newValue.canPay) {
          this.useLoyaltyPointsBalance = false;
        }
        if (this.useLoyaltyPointsBalance) {
          this.setPointsDiscount(this.payByPoint.pointsValue);
        }
      },
    },
    changeData: {
      handler() {
        this.validateFields();
      },
      deep: true,
    },
    changeOrderType: {
      handler() {
        setTimeout(() => this.validateFields(), 500);
      },
      deep: true,
    },
  },
  created() {
    this.setRoomNoFromStorage();
  },
  async mounted() {
    window.addEventListener("focus", this.handleFocus);
    if (isiOS()) {
      window.addEventListener("pageshow", this.handleVisibilityChange);
    } else {
      document.addEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
    }
    try {
      this.fetchingData = true;
      if (this.user) {
        if (!this.dbuser) {
          // check if a user exists with new udid format
          const res = await getDBUser(this.user.id).get();
          let data = res.data();

          if (!data) {
            // fetch with old firebase udid
            const resp = await getDBUser(this.user.id).get();
            data = resp.data();
          }
          this.customerID = data && data.CustomerID ? data.CustomerID : "";
          this.initDetailModel(data);
        } else {
          this.customerID = this.dbuser && this.dbuser.CustomerID ? this.dbuser.CustomerID : "";
          this.initDetailModel(this.dbuser);
        }
      }
      await shared.mounted(false, this);

      if (this.phoneNumber) {
        this.detailModel.Phone = this.phoneNumber;
      }
      const deliveryAddress = JSON.parse(
        sessionStorage.getItem("deliveryAddress")
      );
      if (deliveryAddress) {
        this.deliveryAddressModel = deliveryAddress;
      }
      const pickupTime = sessionStorage.getItem("deliveryTime");
      if (pickupTime) {
        this.selectedPickupTimeChange(pickupTime);
      }
      setTimeout(async () => {
        await this.validateFields();
      }, 3000);
      this.checkOrderFreq();
      setUpTrackingOrderListener(this);
    } catch (exception) {
      logger.log(exception.name, exception.message, "", logger.LogType.Error);
    } finally {
      setTimeout(() => {
        this.fetchingData = false;
      }, 2000);
    }
  },
  beforeRouteEnter(to, from, next) {
    shared.beforeRouteEnter(to, from, next);
  },
  beforeDestroy() {
    if (isiOS()) {
      window.removeEventListener("pageshow", this.handleVisibilityChange);
    } else {
      document.removeEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
    }
    window.removeEventListener("focus", this.handleFocus);
    shared.beforeDestroy(this);
  },
  methods: {
    ...mapActions(["clearCart"]),
    ...shared.methods,
    openPrivacyPolicyModal() {
      this.showPrivacyModal = true;
    },
    closePrivacyPolicyModal() {
      this.$refs.privacyModal.hideModal();
      this.showPrivacyModal = false;
    },
    navigateToShoppingCart() {
      this.$router.push({
        name: "shoppingcartmobile",
        params: {
          storeid: this.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    setCanPayByApple(flag) {
      this.canPayByApple = flag;
    },
    setCanPayByGoogle(flag) {
      this.canPayByGoogle = flag;
    },
    getCheckoutRolldStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push(this.mobileStyles.primaryBodyBackground);
      }
      return styles;
    },
    setBecomeMember(result) {
      this.setBecomeMemberResult(result);
      this.showBecomeMember = false;
      if (this.canPayLater && this.payLaterButtonPressed) {
        this.setMethodAndPlaceOrder(8);
      }
    },

    closeClearCartModal() {
      this.$refs.ClearCartModal.hideModal();
      this.showClearCartModal = false;
      this.cancelClearCart();
    },

    // set detail model data gotten from otp authentication
    initDetailModel(data) {
      if (!data) return;
      this.detailModel.FirstName = data.FirstName;
      this.detailModel.LastName = data.LastName;
      this.detailModel.Email = this.user.email || data.Email;
      this.detailModel.Phone = data.Mobile;
    },

    async validateFields() {
      try {
        const valid = await this.validateOrder(true);
        this.livenDisplay = valid;
      } catch (error) {
        this.livenDisplay = false;
      }
    },

    handleVisibilityChange() {
      if (document.visibilityState === "visible" || isiOS()) {
        // The mobile device is unlocked
        if (this.showSharedCart) {
          this.executeCodeWhenUnlocked();
        }
      }
    },
    handleFocus() {
      // Handle the browser window regaining focus
      if (this.showSharedCart) {
        this.executeCodeWhenUnlocked();
      }
    },
    async executeCodeWhenUnlocked() {
      try {
        await sleep(3000);
        const data = await readProductData(
          this.getSharedCartProps.table,
          this.storeid
        );
        if (!data) {
          this.clearCart();
          this.$router.push(`/store/${this.$route.params.storeid}`);
        } else {
          const names = Object.keys(data);
          if (!names.includes(this.getSharedCartProps.user)) {
            this.clearCart();
            this.$router.push(`/store/${this.$route.params.storeid}`);
          }
        }
      } catch (error) {
        logger.log(
          "shared cart",
          error,
          `/store/${this.storeid}`,
          "error",
          "",
          ""
        );
      }
    },
  },
  destroyed() {
    shared.destroyed();
  },
};
</script>
